import React, { useState, useEffect, useRef } from "react";

import { UpperContainer, HeaderCompendioGratis, Plans, SearchField, InputField, ExportButton, ExportOptions, Desmarc, Search, Titulo, ContainerNew, AddButton, BlockedTooltip, BlockedTooltipLink } from "./styles";
import { Container } from "react-grid-system";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/logo.png";
import ModalText from "../modal/modalText";
import Lupa from "../../assets/icons/lupa.svg";
import Filtro from "../../assets/icons/filtro.svg";
import Download from "../../assets/icons/download.svg";
import InputSearch from "../../components/input-search";
import Add from "../../assets/icons/iconAddHeader.svg";
import Arrow from "../../assets/icons/arrow-white.svg";
import ArrowDown from "../../assets/icons/icons-arrow-down.png";

import ModalGenericV2 from "../modal/modalGenericV2";

import Help from "../../assets/icons/help.svg";
import IconHelp from "../../assets/icons/help";

import { TaglineP, TaglinePSpan } from "../../styles/stylesTypography";
import * as S from './styles'
import maintainUtm from "../../services/maintainUtm";
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";

import TableSolicitacoesV2 from '../totvs/tableSolicitacao/indexV2';

import { store } from 'react-notifications-component';
import ButtonWithTextAndStatus from "../buttonWithTextAndStatus";
import api from "../../services/api";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import MenuHamburgerBlack from "../../assets/icons/icon-menu-hamburguer-black.svg";
import { useHeaderMenu } from "../../contexts/HeaderMenuContext";
export const USER = "@userinfo";
export const OPEN = "@open";


const GenericUpper = ({ ...props }) => {
  const location = useLocation();
  // Renderiza o hambúrguer aqui, na mesma linha do título/botão de plano,
  // em vez de deixar a Navbar desenhar o dela solta na tela.
  const { openMenu, setHasInlineMenuButton } = useHeaderMenu();
  useEffect(() => {
    setHasInlineMenuButton(true);
    return () => setHasInlineMenuButton(false);
  }, []);
  const [showModalHelp, setShowModalHelp] = useState(false);
  const [pesquisar, SetPesquisar] = useState('');
  const [showOptions, SetShowOptions] = useState(false);
  const [isPrePago, setIsPrePago] = useState(false);
  const [isTest, setIsTest] = useState(false);
  const [padding, setPadding] = useState('');

  const [showButtonSynchronize, setShowButtonSynchronize] = useState(false)
  const [hasSynchronize, setHasSynchronize] = useState(false)

  const [loadingWebhookList, setLoadingWebhookList] = useState(false)
  const [WebhookList, setWebhookList] = useState([])

  const [showBlockedInfo, setShowBlockedInfo] = useState(false);
  const addButtonBlockedRef = useRef(null);

  useEffect(() => {
    if (!showBlockedInfo) return;
    const handleClickOutside = (event) => {
      if (addButtonBlockedRef.current && !addButtonBlockedRef.current.contains(event.target)) {
        setShowBlockedInfo(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showBlockedInfo]);

  const getPlansConfig = () => {
    let user = JSON.parse(localStorage.getItem(USER));

    if (user && user !== null) {
      if (user.contrato) {
        if (user.contrato.status) {
          if (user.contrato.status == 'AP') {
            let is_test = user.contrato.agro_plan_config.is_teste;
            let is_prePago = user.contrato.agro_plan_config.is_pre_pago;

            if (is_test === 1) {
              setIsTest(true);
            }

            if (is_prePago === 1) {
              setIsPrePago(true);
            }
          } else {
            setIsTest(false);
          }
        }
      }
    }
  }

  const logincompra = /\/login-compra\//g;
  const simulacaocompra = /\/simulacaoplano\//g;

  useEffect(() => {
    getPlansConfig();
  }, [])

  const formatDateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('pt-BR', { timeZone: 'UTC' });
  };

  const handleReenviarWebhook = async (row) => {
    setLoadingWebhookList(true)
    const webhookId = row?.id;

    try {
      const response = await api.get(`/receitas/webhook/reenviar/${webhookId}`);
     
      if (response.status === 200) {
        store.addNotification({
          title: "Sucesso!",
          message: `Webhook reenviado com sucesso.`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true }
        });
        
        getReceitasWebhookListar()
      }

    } catch (error) {
      console.log("error", `${ error.response.data.errors} ${ error.response.data.message}`)

      store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(error),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true }
        });
    } finally {
      setLoadingWebhookList(false)
    }
  };
  
    const webhookColumns = [
      {
        key: 'numero_receita',
        label: 'Receita',
        minWidth: '90px',
        width: '90px',
        render: (item) => <TaglineP fontWeight={600}>{item?.numero_receita ?? '-'}</TaglineP>
      },
      {
        key: 'integration_url',
        label: 'Webhook URL',
        minWidth: '280px',
        width: '340px',
        maxWidthContent: '340px',
        enableHorizontalScroll: true,
        render: (row) => <p style={{fontSize: '12px'}}>{row?.integration_url || '-'}</p>
      },
      {     
        key: 'modified',
        label: 'Última tentativa',
        minWidth: '180px',
        width: '100%',
        maxWidthContent: '100%',
        render: (row) => <TaglineP fontWeight={600}>{formatDateTime(row?.modified)}</TaglineP>
      },
      {
        key: 'actions',
        label: 'Reenviar',
        minWidth: '120px',
        width: '100%',
        render: (row) => ( <ButtonWithTextAndStatus status={3} text="Enviar" onClick={() => handleReenviarWebhook(row)} />)
      }
    ];

    const getReceitasWebhookPendentes = async () => {
    try {
      const response = await api.get(`/receitas/webhook/pendencias`);

      if (response.data.pendencias === true) {
        setShowButtonSynchronize(true)
      }
    } catch (error) {
      setShowButtonSynchronize(false)

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    }
  }

  const getReceitasWebhookListar = async () => {
    setLoadingWebhookList(true)
    try {
      const response = await api.get(`/receitas/webhook/listar`);

      if (response.status === 200) {
        if (response.data.length > 0) {
          setWebhookList(response.data)
        } else {
          setHasSynchronize(false)
          setShowButtonSynchronize(false)
        }
      }
    } catch (error) {
      setShowButtonSynchronize(false)

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "error",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true }
      });
    } finally {
      setLoadingWebhookList(false)
    }
  }

  useEffect(() => {
    const path = location.pathname;
    if (path === "/checkout" || path.startsWith("/checkout/")) {
      return;
    }else{
      getReceitasWebhookPendentes();
    }
  }, [location.pathname]);

  const userData = JSON.parse(localStorage.getItem("@userinfo"));
  const getPlanName = userData?.contrato?.agro_plan_config?.nome_plano;

  const buttonPlansChange = () => {
    const currentPageId = getCurrentPageIdWithDevice();
    
    switch (getPlanName) {
      case "PLANO PRO":
      case "PLANO LIGHT":
      case "PLANO BASIC":
        return (
          <a href={`/gerenciar-plano${maintainUtm(`${currentPageId}-headergerenciarplano`)}`}>
            <S.ManagePlansButton>
              <TaglinePSpan>GERENCIAR PLANO</TaglinePSpan>
            </S.ManagePlansButton>
          </a>
        );
      case "PLANO PRÉ-PAGO":
        return (
          <a href={`/comprar_receitas${maintainUtm(`${currentPageId}-headercomprarcreditos`)}`}>
            <S.SubscribeButton>
              <TaglinePSpan>COMPRAR CRÉDITOS</TaglinePSpan>
            </S.SubscribeButton>
          </a>
        );
      case "TESTE GRÁTIS":
        return (
          <a href={`/planos${maintainUtm(`${currentPageId}-headerassinaragora`)}`}>
            <S.SubscribeButton>
              <TaglinePSpan>ASSINAR AGORA</TaglinePSpan>
            </S.SubscribeButton>
          </a>
        );
      case "PLANO PROTHEUS":
        return userData?.agro_permission_id !== 4 ? (
          showButtonSynchronize && (
          <ButtonWithTextAndStatus status={3} text="Sincronizar dados" onClick={() => {setHasSynchronize(true); getReceitasWebhookListar()}} />
          )
        ) : null;
      case "PLANO OMIE":
        return userData?.agro_permission_id === 4 ? (
          <a href={`/gerenciar-plano${maintainUtm(`${currentPageId}-headergerenciarplano`)}`}>
            <S.ManagePlansButton>
              <TaglinePSpan>GERENCIAR PLANO</TaglinePSpan>
            </S.ManagePlansButton>
          </a>
        ) : null;
      default:
        return null;
    }
  };

  const getPaddingByPlan = (planName) => {
    switch (planName) {
      case "PLANO PRO":
        return "0";
      case "PLANO LIGHT":
      case "PLANO BASIC":
      case "PLANO PRÉ-PAGO":
      case "TESTE GRÁTIS":
        return "0.7rem";
      default:
        return "0";
    }
  };
  
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem(USER));
    const planName = user?.contrato?.agro_plan_config?.nome_plano;
  
    setPadding(getPaddingByPlan(planName));
  }, []);  

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const currentPageId = getCurrentPageIdWithDevice();
  const search = maintainUtm(`${currentPageId}-headertestegratis`);

  // AddButton (usado nos blocos addButton/addLinkModal abaixo) some via CSS em telas
  // <=768px (ver styles.js). Sem essa checagem, a div "buttons" continuava com
  // display:flex mesmo sem nenhum filho visível, sobrando um espaço vazio reservado
  // no fim do bloco de busca.
  const hasVisibleActionButtons =
    props.hideFilter === false ||
    props.hideExportar === false ||
    ((props.addButton === true || !!props.addLinkModal) && width > 768);

  return (
    <>
      {props.isSite ? (
        <HeaderCompendioGratis>
          <div className="header">
            <div className="logo">
              <a href="http://www.agroreceita.com.br" target="_blank">
                <img src={Logo} alt="logo" />
              </a>
            </div>
            <div className="links">
              <a href="https://www.agroreceita.com.br/ajuda" id="help" target="_blank">AJUDA</a>
              <a href="https://sistema.agroreceita.com.br" target="_blank">ENTRAR</a>
              <a href="https://agroreceita.com.br/blog/" id="blog" target="_blank">BLOG</a>
            </div>
            <div className="planos">
              <a href="https://www.agroreceita.com.br/planos" id="plans" target="_blank">PLANOS</a>
              <a href={`https://sistema.agroreceita.com.br/cadastro`} id="teste" target="_blank">TESTE GRÁTIS</a>
            </div>
          </div>
          <div className="title">
            <h1>{props.title}</h1>
            <h2>{props.subtitle}</h2>
          </div>
        </HeaderCompendioGratis>
      ) : (
        <UpperContainer {...props}>
          {props.showLogo == true && props.showFaq == true ? (<>
            <div className="iconsLogo">
              <div className="logo">
                <a href="http://www.agroreceita.com.br" >
                  <img src={Logo} alt="logo" />
                </a>
              </div>
              <div className="faq">
                <a href="https://www.agroreceita.com.br/ajuda/" target="_blank">
                  FAQ
                </a>
              </div>
            </div>
          </>) : (null)}

          {width > 760 ? (
            <ContainerNew isTest={isTest} isPrePago={isPrePago} hideFilter={props.hideFilter} search={props.search} isMobile={props.isMobile} estados={props.estados}>
              {props.logo == true ? (<>
                <Link to="/">
                  <img src={Logo} alt="logo" style={{ width: "150px", marginLeft: "-28px", marginTop: "-55px" }} />
                </Link>
              </>) : (null)}

              {buttonPlansChange()}

              <S.ContainerTitle search={props.search}>
                <Titulo hideFilter={props.hideFilter} search={props.search} estados={props.estados}>
                  {props.title}

                  {props.help === true && props.text && props.text.replace(/ /g, "") != "" && props.text !== null ? (
                    <IconHelp
                      width='19px'
                      height='19px'
                      fill='#5DA8FD'
                      cursor='pointer'
                      onClick={() => setShowModalHelp(true)}
                    />
                  ) : (null)
                  }</Titulo>
                {/* <small className="subtitleTour">{props.subtitle}</small> */}
                {
                  props.search === true && (
                    <Search>
                      {
                        props.docSeguranca ? (
                          props.onKeyDown ? (
                            <InputSearch
                              placeholder={props.placeholder}
                              estado=""
                              search='0'
                              estados={true}
                              update={(text, isSearch, select) => props.searchFunction(text, isSearch, text)}
                              onChange={(text) => {
                                SetPesquisar(text.target.value);
                              }}
                              onKeyDown={(e) => props.onKeyDown(e)}
                              value={props.valueSelect}
                              docSeguranca={props.docSeguranca}
                              selectEstado={props.estados}
                              pesquisa={props.search}
                            >
                            </InputSearch>
                          ) : (
                            <InputSearch
                              placeholder={props.placeholder}
                              estado=""
                              search='0'
                              estados={true}
                              update={(text, search, documento) => { props.searchFunction(text, search, documento)}}
                              onChange={(text) => {
                                SetPesquisar(text.target.value);
                              }}
                              docSeguranca={props.docSeguranca}
                              value={props.valueSelect}
                              selectEstado={props.estados}
                              pesquisa={props.search}
                            >
                            </InputSearch>
                          )
                        ) : props.onKeyDown ? (
                          <InputSearch
                            placeholder={props.placeholder}
                            estado=""
                            search='0'
                            estados={true}
                            update={(text, estado, search) => props.searchFunction(text, estado, search)}
                            onChange={(text) => SetPesquisar(text.target.value)}
                            onKeyDown={(e) => props.onKeyDown(e)}
                            selectEstado={props.estados}
                            pesquisa={props.search}
                          >
                          </InputSearch>
                        ) : (
                          <InputSearch
                            placeholder={props.placeholder}
                            estado=""
                            search='0'
                            estados={true}
                            update={(text, estado, search) => props.searchFunction(text, estado, search)}
                            onChange={(text) => SetPesquisar(text.target.value)}
                            selectEstado={props.estados}
                            pesquisa={props.search}
                          >
                          </InputSearch>
                        )
                      }
                      <div className="buttons" style={{ display: hasVisibleActionButtons ? 'flex' : 'none' }}>
                        {
                          props.hideFilter == false && (
                            <>
                              <ExportButton style={{ backgroundColor: '#BBC2C6' }} onClick={(val) => props.showFilter(true)}>
                                <img src={Filtro} style={{ width: '13px' }} />
                              </ExportButton>
                              <Desmarc style={{ display: showOptions == true ? 'block' : 'none' }} onClick={() => SetShowOptions(false)}></Desmarc>
                            </>
                          )
                        }
                        {
                          props.hideExportar == false && (
                            <div className="teste" style={{ zIndex: 2 }}>
                              <ExportButton style={{
                                width: '133px'
                              }} onClick={
                                props.linkSearch ? window.location = props.linkSearch : () => SetShowOptions(!showOptions)
                              }>
                                <p>{props.tooltip}</p>
                                <img src={props.disabled ? ArrowDown : Arrow} style={{ marginLeft: '4px', marginTop: '3px' }} />
                              </ExportButton>
                              <ExportOptions style={{ display: showOptions == true ? 'block' : 'none' }}>
                                {
                                  showOptions == true && (
                                    props.searchButtonOptions.map(e => (
                                      <>
                                        {e == 'PR' ? (
                                          <div className="option" onClick={() => props.searchButtonAct(1)}>
                                            <p onClick={() => props.searchButtonAct(1)}>Siagro</p>
                                          </div>
                                        ) : (<>
                                          {e == 'SC' ? (
                                            <div className="option" onClick={() => props.searchButtonAct(2)}>
                                              <p onClick={() => props.searchButtonAct(2)}>Cidasc</p>
                                            </div>
                                          ) : (<>
                                            {e == 'MT' ? (
                                              <div className="option" onClick={() => props.searchButtonAct(3)}>
                                                <p onClick={() => props.searchButtonAct(3)}>Sisdev</p>
                                              </div>
                                            ) : (<>
                                              {e == 'GO' ? (
                                                <div className="option" onClick={() => props.searchButtonAct(4)}>
                                                  <p onClick={() => props.searchButtonAct(4)}>Sidago</p>
                                                </div>
                                              ) : (<>
                                                {e == 'RS' ? (
                                                  <div className="option" onClick={() => props.searchButtonAct(5)}>
                                                    <p onClick={() => props.searchButtonAct(5)}>SDA RS</p>
                                                  </div>
                                                ) : (<>
                                                  {e == 'ES' ? (
                                                    <div className="option" onClick={() => props.searchButtonAct(6)}>
                                                      <p onClick={() => props.searchButtonAct(6)}>IDAF</p>
                                                    </div>
                                                  ) : (<>
                                                    {e === 'BA' ? (
                                                      <div className="option" onClick={() => props.searchButtonAct(7)}>
                                                        <p onClick={() => props.searchButtonAct(7)}>ADAB</p>
                                                      </div>
                                                    ) : (
                                                      <>
                                                        {e === 'MG' ? (
                                                          <div className="option" onClick={() => props.searchButtonAct(8)}>
                                                            <p onClick={() => props.searchButtonAct(8)}>SICCA</p>
                                                          </div>
                                                        ) : (
                                                          <>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </>)}
                                                </>)}
                                              </>)}
                                            </>)}
                                          </>)}
                                        </>)}
                                      </>
                                    ))
                                  )
                                }
                              </ExportOptions>
                            </div>
                          )

                        }
                        {
                          props.addButton == true && (
                            <div className="teste" style={{ zIndex: 2 }} ref={props.addButtonBlockedLinkHref ? addButtonBlockedRef : null}>
                              <AddButton
                              disabled={props.disabled}
                              onClick={
                                props.addButtonBlockedLinkHref ? () => setShowBlockedInfo((v) => !v) : props.disabled ? () => null : props.linkSearch ? () => window.location = props.linkSearch : () => SetShowOptions(!showOptions)
                              }
                              onMouseEnter={
                                props.addButtonBlockedLinkHref ? () => setShowBlockedInfo(true) : undefined
                              }>
                                <p>{props.tooltip}</p>
                                {
                                  props.addOptions == true && (
                                    <img src={props.disabled ? ArrowDown : Arrow} style={{ marginLeft: '3px', marginTop: '3px' }} />
                                  )
                                }
                                {
                                  props.addButtonBlockedLinkHref && (
                                    <BlockedTooltip href={props.addButtonBlockedLinkHref} style={showBlockedInfo ? { display: 'block' } : undefined}>
                                      {props.addButtonBlockedLinkText}{' '}
                                      <BlockedTooltipLink >
                                        aqui
                                      </BlockedTooltipLink>
                                    </BlockedTooltip>
                                  )
                                }
                                
                              </AddButton>
                              {
                                props.addOptions == true && (
                                  <>
                                    <ExportOptions style={{ display: showOptions == true ? 'block' : 'none' }}>
                                      <div className="option" onClick={() => props.addOption01 ? window.location = props.addOption01 : props.addOptionModal ? props.addOptionModal : null}>
                                        <p onClick={() => props.addOption01 ? window.location = props.addOption01 : props.addOptionModal ? props.addOptionModal() : null}>Cadastrar</p>
                                      </div>
                                      <div className="option" onClick={() => props.importar(true)}>
                                        <p onClick={() => props.importar(true)}>Importar</p>
                                      </div>
                                      {/* <div className="option" onClick={() => props.importarFarm(true)}>
                                      <p> Importar Fazendas </p>
                                    </div> */}
                                    </ExportOptions>
                                    <Desmarc style={{ display: showOptions == true ? 'block' : 'none' }} onClick={() => SetShowOptions(false)}></Desmarc>
                                  </>

                                )
                              }
                            </div>
                          )
                        }
                        {
                          props.addLinkModal && (
                            <div className="teste" style={{ zIndex: 2 }}>
                              <AddButton onClick={
                                () => props.addLinkModal()
                              }>
                                <p>{props.tooltip}</p>
                                {
                                  props.addOptions == true && (
                                    <img src={Arrow} style={{ marginLeft: '3px', marginTop: '3px' }} />
                                  )
                                }
                              </AddButton>
                            </div>
                          )
                        }
                      </div>
                    </Search>
                  )
                }

              </S.ContainerTitle>

              {props.headerRight && (
                <div style={{ marginLeft: "auto" }}>
                  {props.headerRight}
                </div>
              )}

            </ContainerNew>
          ) : (
          <>
            <ContainerNew isTest={isTest} isPrePago={isPrePago} hideFilter={props.hideFilter} search={props.search} isMobile={props.isMobile} estados={props.estados} padding={padding}>
              {props.logo == true ? (<>
                <Link to="/">
                  <img src={Logo} alt="logo" style={{ width: "150px", marginLeft: "-28px", marginTop: "-55px" }} />
                </Link>
              </>) : (null)}


              <S.ContainerTitle search={props.search}>
                <S.TitleGroup>
                  <img
                    src={MenuHamburgerBlack}
                    alt="menu"
                    onClick={(e) => { e.stopPropagation(); openMenu(); }}
                    style={{ width: '20px', height: '20px', cursor: 'pointer', flexShrink: 0 }}
                  />

                  <Titulo hideFilter={props.hideFilter} search={props.search} estados={props.estados}>
                    {props.title}

                    {props.help === true && props.text && props.text.replace(/ /g, "") != "" && props.text !== null ? (
                      <IconHelp
                      width='19px'
                      height='19px'
                      fill='#5DA8FD'
                      cursor='pointer'
                      onClick={() => setShowModalHelp(true)}
                      />
                    ) : (null)
                  }</Titulo>
                  {/* <small className="subtitleTour">{props.subtitle}</small> */}
                </S.TitleGroup>
                {buttonPlansChange()}

              </S.ContainerTitle>

              {props.headerRight && (
                <div style={{ marginLeft: "auto" }}>
                  {props.headerRight}
                </div>
              )}

              {
                  props.search === true && (
                    <Search>
                      {
                        props.docSeguranca ? (
                          props.onKeyDown ? (
                            <InputSearch
                              placeholder={props.placeholder}
                              estado=""
                              search='0'
                              estados={true}
                              update={(text, isSearch, select) => props.searchFunction(text, isSearch, text)}
                              onChange={(text) => {
                                SetPesquisar(text.target.value);
                              }}
                              onKeyDown={(e) => props.onKeyDown(e)}
                              value={props.valueSelect}
                              docSeguranca={props.docSeguranca}
                              selectEstado={props.estados}
                              pesquisa={props.search}
                            >
                            </InputSearch>
                          ) : (
                            <InputSearch
                              placeholder={props.placeholder}
                              estado=""
                              search='0'
                              estados={true}
                              update={(text, search, documento) => { props.searchFunction(text, search, documento) }}
                              onChange={(text) => {
                                SetPesquisar(text.target.value);
                              }}
                              docSeguranca={props.docSeguranca}
                              value={props.valueSelect}
                              selectEstado={props.estados}
                              pesquisa={props.search}
                            >
                            </InputSearch>
                          )
                        ) : props.onKeyDown ? (
                          <InputSearch
                            placeholder={props.placeholder}
                            estado=""
                            search='0'
                            estados={true}
                            update={(text, estado, search) => props.searchFunction(text, estado, search)}
                            onChange={(text) => SetPesquisar(text.target.value)}
                            onKeyDown={(e) => props.onKeyDown(e)}
                            selectEstado={props.estados}
                            pesquisa={props.search}
                          >
                          </InputSearch>
                        ) : (
                          <InputSearch
                            placeholder={props.placeholder}
                            estado=""
                            search='0'
                            estados={true}
                            update={(text, estado, search) => props.searchFunction(text, estado, search)}
                            onChange={(text) => SetPesquisar(text.target.value)}
                            selectEstado={props.estados}
                            pesquisa={props.search}
                          >
                          </InputSearch>
                        )
                      }
                      <div className="buttons" style={{ display: hasVisibleActionButtons ? 'flex' : 'none' }}>
                        {
                          props.hideFilter == false && (
                            <>
                              <ExportButton style={{ backgroundColor: '#BBC2C6' }} onClick={(val) => props.showFilter(true)}>
                                <img src={Filtro} style={{ width: '13px' }} />
                              </ExportButton>
                              <Desmarc style={{ display: showOptions == true ? 'block' : 'none' }} onClick={() => SetShowOptions(false)}></Desmarc>
                            </>
                          )
                        }
                        {
                          props.hideExportar == false && (
                            <div className="teste" style={{ zIndex: 2 }}>
                              <ExportButton style={{
                                width: '133px'
                              }} onClick={
                                props.linkSearch ? window.location = props.linkSearch : () => SetShowOptions(!showOptions)
                              }>
                                <p>{props.tooltip}</p>
                                <img src={Arrow} style={{ marginLeft: '4px', marginTop: '3px' }} />
                              </ExportButton>
                              <ExportOptions style={{ display: showOptions == true ? 'block' : 'none' }}>
                                {
                                  showOptions == true && (
                                    props.searchButtonOptions.map(e => (
                                      <>
                                        {e == 'PR' ? (
                                          <div className="option" onClick={() => props.searchButtonAct(1)}>
                                            <p onClick={() => props.searchButtonAct(1)}>Siagro</p>
                                          </div>
                                        ) : (<>
                                          {e == 'SC' ? (
                                            <div className="option" onClick={() => props.searchButtonAct(2)}>
                                              <p onClick={() => props.searchButtonAct(2)}>Cidasc</p>
                                            </div>
                                          ) : (<>
                                            {e == 'MT' ? (
                                              <div className="option" onClick={() => props.searchButtonAct(3)}>
                                                <p onClick={() => props.searchButtonAct(3)}>Sisdev</p>
                                              </div>
                                            ) : (<>
                                              {e == 'GO' ? (
                                                <div className="option" onClick={() => props.searchButtonAct(4)}>
                                                  <p onClick={() => props.searchButtonAct(4)}>Sidago</p>
                                                </div>
                                              ) : (<>
                                                {e == 'RS' ? (
                                                  <div className="option" onClick={() => props.searchButtonAct(5)}>
                                                    <p onClick={() => props.searchButtonAct(5)}>SDA RS</p>
                                                  </div>
                                                ) : (<>
                                                  {e == 'ES' ? (
                                                    <div className="option" onClick={() => props.searchButtonAct(6)}>
                                                      <p onClick={() => props.searchButtonAct(6)}>IDAF</p>
                                                    </div>
                                                  ) : (<>
                                                    {e === 'BA' ? (
                                                      <div className="option" onClick={() => props.searchButtonAct(7)}>
                                                        <p onClick={() => props.searchButtonAct(7)}>ADAB</p>
                                                      </div>
                                                    ) : (
                                                      <>
                                                        {e === 'MG' ? (
                                                          <div className="option" onClick={() => props.searchButtonAct(8)}>
                                                            <p onClick={() => props.searchButtonAct(8)}>SICCA</p>
                                                          </div>
                                                        ) : (
                                                          <>
                                                          </>
                                                        )}
                                                      </>
                                                    )}
                                                  </>)}
                                                </>)}
                                              </>)}
                                            </>)}
                                          </>)}
                                        </>)}
                                      </>
                                    ))
                                  )
                                }
                              </ExportOptions>
                            </div>
                          )

                        }
                        {
                          props.addButton == true && (
                            <div className="teste" style={{ zIndex: 2 }} ref={props.addButtonBlockedLinkHref ? addButtonBlockedRef : null}>
                              <AddButton
                              disabled={props.disabled}
                              onClick={
                                props.addButtonBlockedLinkHref ? () => setShowBlockedInfo((v) => !v) : props.disabled ? () => null : props.linkSearch ? () => window.location = props.linkSearch : () => SetShowOptions(!showOptions)
                              }
                              onMouseEnter={
                                props.addButtonBlockedLinkHref ? () => setShowBlockedInfo(true) : undefined
                              }>
                                <p>{props.tooltip}</p>
                                {
                                  props.addOptions == true && (
                                    <img src={props.disabled ? ArrowDown : Arrow} style={{ marginLeft: '3px', marginTop: '3px' }} />
                                  )
                                }
                                {
                                  props.addButtonBlockedLinkHref && (
                                    <BlockedTooltip style={showBlockedInfo ? { display: 'block' } : undefined}>
                                      {props.addButtonBlockedLinkText}{' '}
                                      <BlockedTooltipLink href={props.addButtonBlockedLinkHref}>
                                        aqui
                                      </BlockedTooltipLink>
                                    </BlockedTooltip>
                                  )
                                }
                              </AddButton>
                              {
                                props.addOptions == true && (
                                  <>
                                    <ExportOptions style={{ display: showOptions == true ? 'block' : 'none' }}>
                                      <div className="option" onClick={() => props.addOption01 ? window.location = props.addOption01 : props.addOptionModal ? props.addOptionModal : null}>
                                        <p onClick={() => props.addOption01 ? window.location = props.addOption01 : props.addOptionModal ? props.addOptionModal() : null}>Cadastrar</p>
                                      </div>
                                      <div className="option" onClick={() => props.importar(true)}>
                                        <p onClick={() => props.importar(true)}>Importar</p>
                                      </div>
                                      {/* <div className="option" onClick={() => props.importarFarm(true)}>
                                      <p> Importar Fazendas </p>
                                    </div> */}
                                    </ExportOptions>
                                    <Desmarc style={{ display: showOptions == true ? 'block' : 'none' }} onClick={() => SetShowOptions(false)}></Desmarc>
                                  </>

                                )
                              }
                            </div>
                          )
                        }
                        {
                          props.addLinkModal && (
                            <div className="teste" style={{ zIndex: 2 }}>
                              <AddButton onClick={
                                () => props.addLinkModal()
                              }>
                                <p>{props.tooltip}</p>
                                {
                                  props.addOptions == true && (
                                    <img src={Arrow} style={{ marginLeft: '3px', marginTop: '3px' }} />
                                  )
                                }
                              </AddButton>
                            </div>
                          )
                        }
                      </div>
                    </Search>
                  )
                }
            </ContainerNew>
          </>)}

          <ModalText
            show={showModalHelp}
            onHide={() => setShowModalHelp(false)}
            text={props.text}
            btnOk={false}
            title={props.toSearch ? "AJUDA" : ""}
            toSearch={props.toSearch}
            textToSearch={props.textToSearch}
          />
        </UpperContainer>

      )}

      {hasSynchronize && (
        <ModalGenericV2 
        show={hasSynchronize} 
        onHide={() => setHasSynchronize(false)}
        marginBottom="0"
        >
          <S.ContainerModal>
            {loadingWebhookList ? (
            <S.LoadingContainer>
              <S.Loading />
            </S.LoadingContainer> 
            ):(
              <TableSolicitacoesV2
                columns={webhookColumns}
                data={WebhookList}
                showAll
                itemsPerPage={WebhookList.length || 16}
                serverSide
                getRowId={(item, idx) => item?.id || idx}
                onRowClick={() => null}
                isRowDisabled={() => true}
              />
            )}
          </S.ContainerModal>
        </ModalGenericV2>
      )}
    </>

  );
}

export default GenericUpper;
